export const emailConfig = {
  serviceID: "service_ens5ttd",
  templateID: "template_0nxrsw7",
  userID: "GcApcmQ5qBvSr24bb",
};
